import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../../Months.scss';

const MONTHS = {
    0: "January",
    1: "February",
    2: "March",
    3: "April",
    4: "May",
    5: "June",
    6: "July",
    7: "August",
    8: "September",
    9: "October",
    10: "November",
    11: "December",
};

const Months = ({currentMonth, onClickMonth, months}) => { 
    let month = new Date().getMonth();
    let year = new Date().getFullYear();
    let m = [];
    let keys = Object.keys(months).map(x => parseInt(x)).sort((a, b) => b - a);
    keys = [... keys, ... keys].slice(0, 12);
    for (let i of keys) {
        m.push({
            number: i,
            month: MONTHS[(12 + i) % 12],
            isCurrent: i === currentMonth
        });
        if (i % 12 === 0) {
            m.push({
                number: i - 1,
                year: --year
            });
        }
    }

    return (
        <div className="months">
          {m.map(
              ({month, number, isCurrent,year}) =>
                  year ?
                  <div
                    onClick={() => onClickMonth(number)}
                    className="month year">{year}</div> :
                   <div
                     onClick={() => onClickMonth(number)}
                     className={isCurrent ? "month current" : "month"}>
                     {month}
                   </div>
                  )}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Months);
